import AuthStore from "@helper/auth/auth-store";

export const getLangParam = () => {
    const user = AuthStore.getState()?.user;
    let language = "en";
    switch (user?.language) {
        case "deu":
            language = "de";
            break;
        case "eng":
            language = "en";
            break;
        default:
            language = "en";
    }
    return `language=${language}`;
};
